export default __webpack_public_path__ + "static/media/happy-coder.4f2d9d29.png";